// import React from "react";
// import { Container, Row, Col, Card, Button } from "react-bootstrap";


// const Services = () => {
//   const services1 = [
//     {
//       title: "wedding",
//       image: "https://images.unsplash.com/photo-1647949940712-bfcf82015d9b?w=700&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDB8fGluZGlhbiUyMHdlZGRpbmd8ZW58MHx8MHx8fDA%3D",
//       desc: "We design elegant decor to transform your wedding space beautifully.",
//     },
//     {
//       title: "Engagement",
//       image: "https://images.unsplash.com/photo-1601120979673-b3f6f4c7d2ba?w=700&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzJ8fGluZGlhbiUyMHdlZGRpbmd8ZW58MHx8MHx8fDA%3D",
//       desc: "Our experts ensure smooth planning from start to finish.",
//     },
//     {
//       title: "Aniversary",
//       image: "",
//       desc: "Enjoy a comfortable and stylish bridal suite experience.",
//     },
//   ];

//   const services2 = [
//     {
//       title: "Birthday Celebration",
//       image: "https://via.placeholder.com/300x200",
//       desc: "Beautiful floral designs to enhance your wedding.",
//     },
//     {
//       title: "Hall Booking",
//       image: "https://via.placeholder.com/300x200",
//       desc: "Timeless decor themes for a classy wedding.",
//     },
//     {
//       title: "wedding planner",
//       image: "https://via.placeholder.com/300x200",
//       desc: "Trendy and modern styles for a stylish wedding.",
//     },
//   ];

//   const renderCard = (item, index) => (
//     <Col md={4} key={index}>
//       <Card className="h-100 shadow-sm border-0">
//         <Card.Img variant="top" src={item.image} />
//         <Card.Body>
//           <Card.Title className="fw-bold">{item.title}</Card.Title>
//           <Card.Text className="text-muted" style={{ fontSize: "14px" }}>
//             {item.desc}
//           </Card.Text>
//           <Button variant="outline-dark" size="sm">
//             Learn More
//           </Button>
//         </Card.Body>
//       </Card>
//     </Col>
//   );

//   return (
//     <Container className="py-5 "style={{marginTop:"100px"}}>

//       {/* Top Section */}
//       <Row className="mb-4">
//         <Col md={6}>
//           <h2 className="fw-bold">
//             Discover Our Exceptional <br /> Wedding Services
//           </h2>
//         </Col>
//         <Col md={6} className="text-muted">
//           <p>
//             We offer a range of services to make your wedding day unforgettable.
//           </p>
//         </Col>
//       </Row>

      
//       <Row className="g-4 mb-5">
//         {services1.map(renderCard)}
//       </Row>


//       <Row className="mb-4">
//         <Col md={6}>

//         </Col>
//         <Col md={6} className="text-muted">
          
//         </Col>
//       </Row>

//       <Row className="g-4">
//         {services2.map(renderCard)}
//       </Row>

//     </Container>
//   );
// };

// export default Services;


import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import Aniversary from "../../Images/Aniversary.jpeg";

const Services = () => {
  const services1 = [
    {
      title: "Wedding",
      image:
        "https://images.unsplash.com/photo-1647949940712-bfcf82015d9b?w=700&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDB8fGluZGlhbiUyMHdlZGRpbmd8ZW58MHx8MHx8fDA%3D",
      desc: "We design elegant decor to transform your wedding into a truly magical and unforgettable celebration.",
    },
    {
      title: "Engagement",
      image:
        "https://images.unsplash.com/photo-1601120979673-b3f6f4c7d2ba?w=700&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzJ8fGluZGlhbiUyMHdlZGRpbmd8ZW58MHx8MHx8fDA%3D",
      desc: "Celebrate your engagement with stylish decor, romantic themes, and a memorable ambiance.",
    },
    {
      title: "Aniversary",
      image: Aniversary,
      desc: "Make your anniversary special with beautiful setups, personalized themes, and a warm, elegant atmosphere.",
    },
  ];

  const services2 = [
    {
      title: "Birthday Celebration",
      image:
        "https://tse3.mm.bing.net/th/id/OIP.0os3lP858MLulxMfMoHdDAHaE8?pid=Api&P=0&h=180",
       desc: "Celebrate your special day with stunning decor, personalized themes, and a lively atmosphere.",
    },
    {
    title: "Hall Booking / Hotel Booking",
      image:
        "https://valura.in/wp-content/uploads/2024/11/Things-to-Check-Before-Booking-a-Wedding-Hall-in-Bangalore.jpg",
       desc: "Book elegant halls and comfortable hotel stays for weddings, events, and special occasions.",
    },
    {
      title: "party and event",
      image:
        "https://media.npr.org/assets/img/2022/11/04/gettyimages-1183414292-1-_slide-edff8c3fe6afcab5c6457e3c7bd011f5c1745161-s1100-c50.jpg",
     desc: "Complete planning and arrangements for parties, events, and celebrations.",
    },
  ];
  const handleWhatsApp = (serviceName) => {
  const text = `
Hello Sangam Guest House and Mairrage Lawn,
I want to book for ${serviceName}.

Please share booking details.
  `.trim();

  const encodedText = encodeURIComponent(text);
  const waNumber = "918882062122"; 
  const url = `https://wa.me/${waNumber}?text=${encodedText}`;

  window.open(url, "_blank");
};

  const renderCard = (item, index) => (
    <Col md={4} key={index}>
      <Card className="h-100 shadow-sm border-0">
        <Card.Img
          variant="top"
          src={item.image}
          style={{
            height: "220px",
            objectFit: "cover",
            width: "100%",
          }}
        />
        <Card.Body className="d-flex flex-column">
          <Card.Title className="fw-bold">{item.title}</Card.Title>
          <Card.Text
            className="text-muted"
            style={{ fontSize: "14px", minHeight: "45px" }}
          >
            {item.desc}
          </Card.Text>
{/* 
          <Button
            style={{
              backgroundColor: "red",
              border: "none",
              color: "white",
              width: "fit-content",
            }}
            size="sm"
          >
            Booking Now
          </Button> */}

      <Button
  size="sm"
  style={{
    backgroundColor: "#ff3b1f",
    border: "none",
    color: "white",
    width: "fit-content",
    display: "block",
    margin: "0 auto",
    padding: "8px 20px",
    transition: "0.3s ease",
  }}
  onClick={() => handleWhatsApp(item.title)}
  onMouseEnter={(e) => {
    e.target.style.backgroundColor = "#ff6a4d";
  }}
  onMouseLeave={(e) => {
    e.target.style.backgroundColor = "#ff3b1f";
  }}
>
  Booking Now
</Button>
        </Card.Body>
      </Card>
    </Col>
  );

  return (
    <Container className="py-5" style={{ marginTop: "100px" }}>
  
      <Row className="mb-4 align-items-center">
        <Col md={6}>
          <h2 className="fw-bold">
            Discover Our Exceptional <br /> Wedding Services
          </h2>
        </Col>
        <Col md={6} className="text-muted">
          {/* <p>
            We offer a range of services to make your wedding day unforgettable.
          </p> */}
        </Col>
      </Row>

      <Row className="g-4 mb-5">{services1.map(renderCard)}</Row>

      <Row className="g-4">{services2.map(renderCard)}</Row>
    </Container>
  );
};

export default Services;